import { ClaimsCounts } from '../../../api/types';
import { ClaimShopCarrier } from '../../parcel-finder/claims/types';
import { allCountries } from '../../parcel-finder/claims/countries';

function useCarriersOptions(carriers: ClaimShopCarrier[], claimsCounts: ClaimsCounts) {
  if (!carriers || carriers.length === 0 || !claimsCounts || !claimsCounts?.carriers) {
    return [];
  }

  const getCarrierKey = (carrier: ClaimShopCarrier) => `${carrier.code}-${carrier.countryCode}`;

  const relevantCarriers = carriers
    .filter((carrier) => claimsCounts.carriers.hasOwnProperty(getCarrierKey(carrier)))
    .sort((a, b) => claimsCounts.carriers[getCarrierKey(b)] - claimsCounts.carriers[getCarrierKey(a)]);

  return relevantCarriers.map((carrier) => {
    const countryName = allCountries[carrier.countryCode] || '';
    const label = `${carrier.name} ${countryName}`;
    return {
      label: label,
      buttonLabel: label,
      value: `${carrier.code}-${carrier.countryCode}`,
    };
  });
}

export default useCarriersOptions;
